import React from 'react'
import Badge from '@material-ui/core/Badge'
import NotificationsIcon from '@material-ui/icons/Notifications'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  // badge: {
  //   backgroundColor: 'red',
  // },
  // icon: {
  //   height: '1em',
  //   display: 'block',
  //   marginRight: 'auto',
  //   marginLeft: 'auto',
  //   marginBottom: 4,
  // },
  wrapper: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
  },
  badgeWrapper: {
    '& .MuiBadge-badge': {
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%',
      right: '50%',
      top: '25%',
    },
  },
})

export const NotificationsItemIcon = withStyles(styles)(
  ({ unreadCount, badgeStyles, iconStyles, classes }) => {
    if (unreadCount === 0) {
      return (
        <div className={classes.wrapper}>
          <NotificationsIcon className={iconStyles} />
        </div>
      )
    }

    return (
      <div className={classes.wrapper}>
        <Badge
          badgeContent={unreadCount}
          classes={{
            badge: badgeStyles,
            root: classes.badgeWrapper,
          }}
        >
          <NotificationsIcon className={iconStyles} />
        </Badge>
      </div>
    )
  },
)

export default NotificationsItemIcon
